import styled from 'styled-components';

export const HalfPageAdsWrapper = styled.div<{ adContainerHeight: number }>`
  width: 300px;
  height: ${(props) => `${props.adContainerHeight}px`};
`;

export const HalfPageAdsItem = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 70px;
  height: 600px;
  margin-bottom: 30px;
`;
